<template>
    <div>
        <el-row>
            <el-col :span="24" style="text-align: left; padding-top: 30px;">
                <span class="mainTitle">
                    舟山辰熙新材料有限公司 简介
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12"  style="text-align: left;padding:20px 60px;">
                <span  class="mainContent">
                    舟山辰熙新材料有限公司（简称辰熙新材料）成立于2021年，是一家专业的化工品及化工衍生品贸易分销公司，公司设在舟山。
                     舟山辰熙作为一个专业的化工品分销商，在行业内拥有良好声誉。主营聚醚多元醇、聚合物多元醇，表面活性剂、分散剂、催化剂、丙二醇、四氯乙烯等一系列产品，拥有专业化的营销团队、丰富的产品渠道和稳定的客户群体，提供全链条营销服务及解决方案，在汽车、家用电器、电子、通讯、医疗、食品、日用化工等领域具有较高的市场占有率。
<br>
<br>
<b>企业愿景：坚持“创新、绿色、共享、增长”的发展理念，提供创新、优质、绿色的产品、服务和综合解决方案，致力于成为领先的创新型新材料企业</b>
                </span>
                
            </el-col>
            <el-col :span="12"  style="text-align: left;padding:20px 60px;">
                <img src="../../../../assets/images/companyInfo.png" class="mainPic"/>
                
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "cn_main",
        components: {},
        data() {
            return {

            }
        }
    }
</script>